export default "/assets/markers/deliveries_hover.png"